const initialState = {
  status: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "ISDIRTY_SUCCESS":
      return {  status: action.data };
    case "ISDIRTY_OUT":
      return initialState;
    default:
      return state;
  }
}
